
import React, { useState } from "react";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
  initialRating?: number;
  onChange?: (rating: number) => void;
  readOnly?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function StarRating({
  initialRating = 0,
  onChange,
  readOnly = false,
  size = "md",
  className,
}: StarRatingProps) {
  const [rating, setRating] = useState(initialRating);
  const [hoverRating, setHoverRating] = useState(0);

  const sizes = {
    sm: "h-3 w-3",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  };

  const handleRatingChange = (newRating: number) => {
    if (readOnly) return;
    setRating(newRating);
    onChange?.(newRating);
  };

  return (
    <div 
      className={cn("flex items-center gap-1", className)}
      onMouseLeave={() => !readOnly && setHoverRating(0)}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <Star
          key={star}
          className={cn(
            sizes[size],
            "cursor-pointer transition-colors",
            ((hoverRating && hoverRating >= star) || (!hoverRating && rating >= star))
              ? "text-yellow-400 fill-yellow-400"
              : "text-gray-300",
            readOnly && "cursor-default"
          )}
          onMouseEnter={() => !readOnly && setHoverRating(star)}
          onClick={() => handleRatingChange(star)}
        />
      ))}
    </div>
  );
}
